import React from "react"
import styled, { css } from "styled-components"

import UnfilledBlueOne from "@images/contact/Unfilled-blue-01.svg"
import UnfilledBlueTwo from "@images/contact/Unfilled-blue-02.svg"
import UnfilledBlueThree from "@images/contact/Unfilled-blue-03.svg"
import FilledBlueOne from "@images/contact/Filled-blue-01.svg"
import FilledBlueTwo from "@images/contact/Filled-blue-02.svg"
import FilledBlueThree from "@images/contact/Filled-blue-03.svg"
import UnfilledGreyTwo from "@images/contact/Unfilled-grey-02.svg"
import UnfilledGreyThree from "@images/contact/Unfilled-grey-03.svg"

const size = {
  tablet: 950,
  mobile: 600,
}

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const FormStepsContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  hr {
    border-bottom: 1px solid #e2e8f0;
    margin: 0 8px;
    ${above.mobile`
    margin: 0 16px;
    `}
    &.step-completed {
      border-color: var(--pacific-blue);
    }
  }

  .step-three {
    align-self: flex-start;
  }
`

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 104px;
  img {
    width: 20px;
    margin-bottom: 8px;
  }
  p {
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    color: var(--grey);
    max-width: 72px;
    text-align: center;
    margin-bottom: 0;
  }

  &.step-completed {
    cursor: pointer;
  }
`

const FormStepsWrapper = styled.div`
  .bottom-hr {
    border-bottom: 1px solid #e2e8f0;
  }
`

const FormSteps = ({
  complaintsForm,
  errors,
  watchAllFields,
  dirtyFields,
  step,
  stepOneCompleted,
  stepTwoCompleted,
  setStep,
  setStepOneCompleted,
  setStepTwoCompleted,
}) => {
  const stepOneCheck =
    watchAllFields.email && watchAllFields.name && watchAllFields.phone
  const stepTwoCheck = complaintsForm
    ? watchAllFields.email &&
      watchAllFields.name &&
      watchAllFields.phone &&
      watchAllFields.property_street_address &&
      watchAllFields.city &&
      watchAllFields.state &&
      watchAllFields.zip
    : watchAllFields.email &&
      watchAllFields.name &&
      watchAllFields.phone &&
      watchAllFields.borrower_name &&
      watchAllFields.property_street_address &&
      watchAllFields.city &&
      watchAllFields.state &&
      watchAllFields.zip
  const stateThreeCheck = complaintsForm
    ? watchAllFields.email &&
      watchAllFields.name &&
      watchAllFields.phone &&
      watchAllFields.property_street_address &&
      watchAllFields.city &&
      watchAllFields.state &&
      watchAllFields.zip &&
      watchAllFields.message
    : watchAllFields.email &&
      watchAllFields.name &&
      watchAllFields.phone &&
      watchAllFields.borrower_name &&
      watchAllFields.property_street_address &&
      watchAllFields.city &&
      watchAllFields.state &&
      watchAllFields.zip &&
      watchAllFields.message
  function numberStateOne() {
    if (stepOneCompleted) {
      if (stepOneCheck) {
        return FilledBlueOne
      } else return UnfilledBlueOne
    } else if (dirtyFields.email && dirtyFields.name && dirtyFields.phone) {
      return FilledBlueOne
    } else return UnfilledBlueOne
  }

  function numberStateTwo() {
    if (stepTwoCompleted) {
      if (stepTwoCheck) {
        return FilledBlueTwo
      } else return UnfilledBlueTwo
    } else if (stepTwoCheck) {
      return FilledBlueTwo
    } else if (step === "two") {
      return UnfilledBlueTwo
    } else {
      return UnfilledGreyTwo
    }
  }

  function numberStateThree() {
    if (stateThreeCheck) {
      return FilledBlueThree
    } else if (step === "three") {
      return UnfilledBlueThree
    } else return UnfilledGreyThree
  }

  return (
    <FormStepsWrapper>
      <FormStepsContainer watchAllFields={watchAllFields}>
        <StepContainer
          className={
            Object.keys(errors).length === 0 && stepOneCheck
              ? "step-completed"
              : undefined
          }
          onClick={
            Object.keys(errors).length === 0 && stepOneCheck
              ? () => {
                  setStep("one")
                }
              : undefined
          }
        >
          <img src={numberStateOne()} alt="number one icon" />
          <p>Contact information</p>
        </StepContainer>
        <hr
          className={
            Object.keys(errors).length === 0 && stepOneCheck
              ? "step-completed"
              : undefined
          }
        />
        <StepContainer
          className={
            Object.keys(errors).length === 0 && stepOneCheck
              ? "step-completed"
              : undefined
          }
          onClick={
            Object.keys(errors).length === 0 && stepOneCheck
              ? () => {
                  setStep("two")
                  setStepOneCompleted(true)
                }
              : undefined
          }
        >
          <img src={numberStateTwo()} alt="number two icon" />
          <p>Loan information</p>
        </StepContainer>
        <hr
          className={
            Object.keys(errors).length === 0 && stepTwoCheck
              ? "step-completed"
              : undefined
          }
        />
        <StepContainer
          className={
            Object.keys(errors).length === 0 && stepTwoCheck
              ? "step-completed step-three"
              : "step-three"
          }
          onClick={
            Object.keys(errors).length === 0 && stepTwoCheck
              ? () => {
                  setStep("three")
                  setStepTwoCompleted(true)
                }
              : undefined
          }
        >
          <img src={numberStateThree()} alt="number three icon" />
          <p>Message</p>
        </StepContainer>
      </FormStepsContainer>
      <hr className="bottom-hr" />
    </FormStepsWrapper>
  )
}

export default FormSteps
